import React from "react";
import { TaskUser } from "../types";

interface UserAvatarProps {
    user?: TaskUser | null;
    size?: "xs" | "sm" | "md" | "lg";
    showName?: boolean;
    showPhone?: boolean;
    className?: string;
}

const sizeClasses = {
    xs: "w-6 h-6 text-xs",
    sm: "w-7 h-7 text-xs",
    md: "w-8 h-8 text-sm",
    lg: "w-9 h-9 text-sm",
};

export const UserAvatar: React.FC<UserAvatarProps> = ({
    user,
    size = "md",
    showName = false,
    showPhone = false,
    className = "",
}) => {
    const sizeClass = sizeClasses[size];
    const initial = user?.name?.charAt(0).toUpperCase() || "?";

    if (!user?.name) {
        return (
            <div
                className={`${sizeClass} rounded-full bg-slate-100 flex items-center justify-center ${className}`}
            >
                <i className="fas fa-user-slash text-slate-400 text-xs" />
            </div>
        );
    }

    return (
        <div
            className={`${sizeClass} rounded-full bg-gradient-to-br from-indigo-500 to-purple-600 flex items-center justify-center text-white font-medium shrink-0 ${className}`}
        >
            {initial}
        </div>
    );
};

interface UserDisplayProps {
    user?: TaskUser | null;
    avatarSize?: "xs" | "sm" | "md" | "lg";
    showPhone?: boolean;
    nameClassName?: string;
    phoneClassName?: string;
    className?: string;
}

export const UserDisplay: React.FC<UserDisplayProps> = ({
    user,
    avatarSize = "md",
    showPhone = true,
    nameClassName = "",
    phoneClassName = "",
    className = "",
}) => {
    if (!user?.name) {
        return (
            <div className={`flex items-center gap-2 ${className}`}>
                <UserAvatar user={null} size={avatarSize} />
                <span className="text-sm text-slate-500">Unassigned</span>
            </div>
        );
    }

    return (
        <div className={`flex items-center gap-2 ${className}`}>
            <UserAvatar user={user} size={avatarSize} />
            <div className="min-w-0 flex-1">
                <p
                    className={`text-sm font-medium text-slate-900 truncate ${nameClassName}`}
                >
                    {user.name}
                </p>
                {showPhone && user.phonenum && (
                    <p
                        className={`text-xs text-slate-500 truncate ${phoneClassName}`}
                    >
                        {user.phonenum}
                    </p>
                )}
            </div>
        </div>
    );
};
